(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Util = {};
    
    M2.Util = {
        config: {
            name: "M2 Fundraising Utilities"
        },
        isMobile: {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (M2.Util.isMobile.Android() || M2.Util.isMobile.BlackBerry() || M2.Util.isMobile.iOS() || M2.Util.isMobile.Opera() || M2.Util.isMobile.Windows());
            }
        },
        init: function () {
        },
        stopMediaPlayer: function () {
            // Stop any videos that are playing
            try {
                //Loop and Stop
                let i;
                const videoPlayers = M2.Video.getAllPlayers();
                for (var key in videoPlayers) {
                    videoPlayers[key].pause();
                }
            } catch (err) {
                console.log(err.message);
            }
        }
    }
})(jQuery);

$(function () {
    M2.Util.init();
});